/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React from 'react'

import type { NormalisedResourceRoleAssignment } from '@modules/role-assignments-lib/types'
import type { MemberOrApiKey } from '@modules/role-assignments-components/ProjectRoleAssignmentsSummary'
import CCMRoleAssignmentsSummary from '@modules/role-assignments-components/CCMRoleAssignmentsSummary'
import { useGetCCMClusters } from '@modules/ccm-admin-lib/hooks'

import type { FunctionComponent } from 'react'

const AdminCCMRoleAssignmentsSummary: FunctionComponent<{
  memberOrApiKey: MemberOrApiKey
  organizationId: string
  roleAssignments: Array<NormalisedResourceRoleAssignment<'cloud-connected'>>
}> = ({ memberOrApiKey, organizationId, roleAssignments }) => {
  const queryResult = useGetCCMClusters({
    queryParameters: {
      organization_id: organizationId,
    },
  })

  return (
    <CCMRoleAssignmentsSummary
      memberOrApiKey={memberOrApiKey}
      roleAssignments={roleAssignments}
      queryHookResult={queryResult}
    />
  )
}

export default AdminCCMRoleAssignmentsSummary
